import { useParams, useLocation } from 'react-router';
import ChatActiveDetail from './ChatActiveDetail';
import ChatBroadcastDetail from './ChatBroadcastDetail';
import ChatArchiveDetail from './ChatArchiveDetail';

export default function ChatDetail() {
  const { type } = useParams();
  const location = useLocation();

  if (location.pathname.includes('/broadcast/')) {
    return <ChatBroadcastDetail />;
  }

  if (type === 'archived') {
    return <ChatArchiveDetail />;
  }

  return <ChatActiveDetail />;
}
